import HeroIcon from "./HeroIcon";
import "./hero-icon.scss";

export default HeroIcon;
